import { useMemoizedFn } from "ahooks";
import { useEffect, useState } from "react";
import { getVirtualNodeOriginId } from "../core";
import { GetterPiNode as _GetterPiNode } from "./GetterPinode";
export class GetterPiNode extends _GetterPiNode {}

/**
 * 获取节点
 * 普通节点： expand节点，并返回节点
 * 过滤器路径： expand过滤器源节点，返回过滤器路径
 * 过滤器叶子节点：expand过滤器源节点和过滤器路径节点，返回原始节点
 *
 * @param orgConnection
 * @param nodeId
 * @param expandAll
 */
export const usePiNode = (orgConnection, nodeId, expandAll = false, onExpandAfterError) => {
  const initialGetterPiNode = (() => {
    if (!orgConnection) return null;
    if (!nodeId) return null;
    try {
      return new GetterPiNode(orgConnection.nodeManager.getNode(nodeId));
    } catch (error) {
      return null;
    }
  })();
  const [getterNode, setGetterNode] = useState(initialGetterPiNode);

  /**
   * 订阅
   */
  useEffect(() => {
    if (orgConnection) {
      orgConnection.nodeManager?.unListen("change", loadData);
    }
    if (!orgConnection || !nodeId) {
      setGetterNode(null);
    } else {
      loadData();
      orgConnection.nodeManager.listen("change", loadData);
    }
    return () => {
      if (orgConnection) {
        orgConnection.nodeManager?.unListen("change", loadData);
      }
    };
  }, [orgConnection, nodeId]);
  const loadData = useMemoizedFn(async loadTargetNodeId => {
    if (!orgConnection || !nodeId) return;
    const [originId] = getVirtualNodeOriginId(orgConnection.nodeManager, nodeId);
    let resNodeId = nodeId;
    let expandId = loadTargetNodeId || originId;
    if (expandAll) {
      await orgConnection.expandAll();
    } else {
      /**
       * 虚拟路径节点 需要展开源节点
       * originId>path   ->    expand originId
       *
       * 虚拟叶子节点 需要展开节点(5/11 也是只要展开源节点)
       * originId>path>nodeId   ->  expand nodeId
       */
      await orgConnection.expandTo(expandId);

      // 叶子节点,还要展开叶子节点的虚拟父路径
      // 如果id有> 也有 _ 那就是叶子节点
      if (~nodeId.indexOf(">") && ~nodeId.indexOf("_")) {
        const nodeSplits = nodeId.split("_");
        resNodeId = nodeSplits[nodeSplits.length - 1];
        await orgConnection.expandTo(nodeSplits[0], true);
      }
    }
    const data = orgConnection.nodeManager.findChildren(resNodeId);
    if (data) {
      setGetterNode(new GetterPiNode(data));
    } else {
      if (onExpandAfterError) {
        onExpandAfterError(nodeId, expandId, resNodeId);
      }
      console.warn(`[usePiNode]${onExpandAfterError ? "(onExpandAfterError)" : "(not onExpandAfterError)"}:expand失败，节点不存在`, nodeId, expandId, resNodeId);
      setGetterNode(null);
    }
  });
  const getPiNode = useMemoizedFn(nodeId => {
    return orgConnection?.nodeManager.findChildren(nodeId) || null;
  });
  return [getterNode, loadData, getPiNode];
};